import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import config from '../../../config';
import { Cell } from "recharts";
import { LabelList } from "recharts";

export default function TeacherLoad() {
  const [teacherLoad, setTeacherLoad] = useState([]);
  const academicYear = "2026-2027";

  useEffect(() => {
    fetchLoad();
  }, []);

  const fetchLoad = async () => {
    const res = await axios.get(
      `${config.apiBaseUrl}/academic/get-school-timetable.php`,
      { params: { academic_year: academicYear } }
    );

    if (res.data.success) {
      setTeacherLoad(res.data.teacher_load || []);
    }
  };

  return (
    <div>
      <h5>Teacher Weekly Load</h5>
      <table className="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Teacher</th>
            <th>Total Periods</th>
          </tr>
        </thead>
        <tbody>
          {teacherLoad.map((t, index) => (
            <tr key={index}>
              <td>{t.fullname}</td>
              <td>{t.total_periods}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ width: "100%", height: 320 }}>
        <ResponsiveContainer>
          <BarChart data={teacherLoad}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fullname" />
            <YAxis />
            <Tooltip />
            {/* <Bar dataKey="total_periods" fill="#4e73df" radius={[6, 6, 0, 0]} /> */}
            <Bar dataKey="total_periods">
              {teacherLoad.map((entry, index) => {
                let color = "#1cc88a"; // default green

                if (entry.total_periods >= 25) {
                  color = "#e74a3b"; // red (overload)
                } else if (entry.total_periods >= 15) {
                  color = "#f6c23e"; // yellow (medium)
                }

                return <Cell key={`cell-${index}`} fill={color} />;
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}